import currency from 'currency.js'
import { getCurrency } from 'utils/authService'

export const toBarChartData = data => {
  if (!data) return {}
  let totalCount = 0
  let totalValue = 0
  let totalWonValue = 0
  let totalCostValue = 0
  let totalProfitValue = 0
  const keys = Object.keys(data)
  const reducedData = Object.keys(data).reduce(
    (a, item) => {
      const elem = data[item]
      totalValue += elem.totalValue
      totalWonValue += elem.totalWonValue
      totalCostValue += elem.totalCostValue
      totalProfitValue += elem.totalProfitValue
      totalCount += elem.count

      a.barByValue.push({
        id: item,
        currency: `${getCurrency().symbol}`,
        [item]: currency(elem.totalValue).value
      })

      a.stackedBarByValue[item] = currency(elem.totalValue).value

      return a
    },
    { barByValue: [], stackedBarByValue: { id: getCurrency().symbol } }
  )

  return {
    keys,
    barByValue: reducedData.barByValue.reverse(),
    stackedBarByValue: reducedData.stackedBarByValue,
    totalCount,
    totalValue,
    totalWonValue,
    totalCostValue,
    totalProfitValue
  }
}

export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

export const toStages = stages =>
  stages.map(stage => ({
    value: stage.id,
    label: stage.name,
    color: stage.color,
    categoryColor: stage.category.color
  }))

export const getColors = (bar, stages) => {
  const colors = stages.reduce((a, stage) => {
    a[stage.label] = stage.color || stage.categoryColor
    return a
  }, {})

  return colors[bar.id]
}
